import { MenuItem } from "@mui/material";
import {
  clearAllAggregates,
  updateTrendsPageFilterState,
} from "../../../providers/GlobalStateProvider";
import type { TrendsPageFilterStateType } from "../../../types/types";
import { useDispatch } from "react-redux";
import { useTrendsPageFilterState } from "utils/customHooks/genericHooks";
import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import {
  ALL_GROUP_NAME_DISPLAY,
  ALL_PNL_CATEGORY_NAME_DISPLAY,
  ALL_SHIFT_NAME_DISPLAY,
  ALL_TAG_NAME_DISPLAY,
  createAllProcessGroup,
} from "./filtersDrawerUtils";

const FilterByWorkScheduleDropdownItems = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { trendsPageFilterState } = useTrendsPageFilterState();
  const [workScheduleConfigList] = useWorkScheduleConfigJsonListAtom();
  const isReady = workScheduleConfigList.length > 0;

  if (!isReady) {
    return null;
  }

  const selectedSchedule = trendsPageFilterState.workScheduleId
    ? trendsPageFilterState.workScheduleId
    : workScheduleConfigList[0]?.id;

  const handleGroupDropdownChange = evt => {
    const newWorkScheduleIdFilter = String(evt.target.value);

    // ...if the workscheuldeid was changed from the previous value...
    if (trendsPageFilterState.workScheduleId !== newWorkScheduleIdFilter) {
      const process = createAllProcessGroup("").processes[0];

      process.workScheduleConfig.id = newWorkScheduleIdFilter;
      const newFilterState: TrendsPageFilterStateType = {
        ...trendsPageFilterState,
        group: ALL_GROUP_NAME_DISPLAY,
        tag: ALL_TAG_NAME_DISPLAY,
        shiftName: ALL_SHIFT_NAME_DISPLAY,
        pnlCategory: ALL_PNL_CATEGORY_NAME_DISPLAY,
        process: process,
        workScheduleId: newWorkScheduleIdFilter,
      };
      dispatch(updateTrendsPageFilterState({ newFilterState }));
    }
  };

  return (
    <>
      {workScheduleConfigList.map(workScheduleConfig => {
        return (
          <MenuItem
            key={workScheduleConfig.id}
            value={workScheduleConfig.id}
            onClick={event => {
              event.stopPropagation();
              if (selectedSchedule !== workScheduleConfig.id) {
                dispatch(clearAllAggregates());
                handleGroupDropdownChange(event);
                handleClose();
              }
            }}
          >
            {workScheduleConfig.id} - {workScheduleConfig.name}
          </MenuItem>
        );
      })}
    </>
  );
};

export default FilterByWorkScheduleDropdownItems;
